import { Drawer as AntdDrawer, type DrawerProps } from "antd"
import { cn } from "styles/cn"

export type { DrawerProps } from "antd"

export const Drawer = ({
	rootClassName,
	className,
	classNames,
	mask,
	size = "540",
	...props
}: DrawerProps) => {
	const customClassNames =
		typeof classNames === "object" && classNames !== null
			? classNames
			: undefined

	return (
		<AntdDrawer
			autoFocus
			mask={
				typeof mask === "object"
					? { closable: true, ...mask }
					: (mask ?? { closable: true })
			}
			size={size}
			destroyOnHidden
			closeIcon={null}
			rootClassName={cn("absolute z-10", rootClassName)}
			getContainer={document.getElementById("layout-content")!}
			{...props}
			aria-labelledby={props["aria-labelledby"] ?? ""}
			className={cn("gap-4 overflow-hidden p-5", className)}
			classNames={{
				...customClassNames,
				body: cn(
					"flex flex-col gap-6 overflow-hidden p-0",
					customClassNames?.body,
				),
				header: cn("border-0 p-0", customClassNames?.header),
			}}
		/>
	)
}
